export const getVideoImageUrl = (videoUrl: string, defaultUrl: string) => {
	if (videoUrl.includes('youtube')) {
		const youtubeId = videoUrl?.split('v=')[1];
		return `https://i3.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`;
	}
	return defaultUrl;
};
